import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../layout/Others/Response_Processing";
import AdminSaveHeader from "../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import Wrapper from "../../components/CommonComponents/Wrapper";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import AdminCustomButton from "../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import AdminCustomInput from "../../components/CommonComponents/AdminCustomInput";
import { useMyContext } from "../../components/Provider/CommonProvider";
import AdminBackNavigation from "../../components/CommonComponents/AdminBackNavigation";
import AdminImageUploadZone from "../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomSelect from "../../components/CommonComponents/AdminCustomSelect";
import JoditEditor from "jodit-react";

const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - (offset * 60 * 1000));
    return localDate.toISOString().slice(0, 16);
};

function AddPushNotification() {
    const { fetchRequest, globalImageUplaodAPI, infoBoxModelClose } = useMyContext();
    const baseURL = process.env.REACT_APP_Baseurl;
    const navigate = useNavigate();
    const { id } = useParams();
    const isEdit = !!id;
    const combinedRef = useRef({
        title: null,
        description: null
    });

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        image: '',
        url: '',
        url_type: 'site_url',
        publish_type: 'publish_now',
        publish_time: ''
    });
    const [formDataError, setFormDataError] = useState({});
    const [imageFile, setImageFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        if (isEdit) {
            fetchNotificationDetail();
        }
    }, [id]);

    const fetchNotificationDetail = async () => {
        setLoading(true);
        try {
            const resp = await fetchRequest({
                method: 'GET',
                url: `${baseURL}/admin/push-notification-messages/edit/${id}`,
                infoBoxModelClose
            });
            if (resp?.status) {
                setFormData({
                    title: resp.data.title,
                    description: resp.data.description,
                    image: resp.data.image,
                    url: resp.data.url || '',
                    url_type: resp.data.url_type || 'site_url',
                    publish_type: resp.data.publish_type || 'publish_now',
                    publish_time: formatDateForInput(resp.data.publish_time)
                });
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to fetch details");
        } finally {
            setLoading(false);
        }
    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setFormDataError(prev => ({ ...prev, [name]: '' }));
    };

    const handleFileChange = (e) => {
        const { files, name } = e.target;
        if (files?.length > 0) {
            setImageFile(files[0]);
            setFormDataError(prev => ({ ...prev, image: '' }));
        }
    };

    const handleClearSelectFile = () => {
        setImageFile(null);
    };

    const formValidation = () => {
        let isValid = true;
        let errors = {};
        if (!formData.title) {
            errors.title = "Title is required";
            isValid = false;
        }
        if (!formData.description) {
            errors.description = "Description is required";
            isValid = false;
        }
        setFormDataError(errors);
        return isValid;
    };

    const handleStore = async (e) => {
        if (e) e.preventDefault();
        if (!formValidation()) return;

        setShowOverlay(true);
        try {
            const url = isEdit
                ? `${baseURL}/admin/push-notification-messages/update/${id}`
                : `${baseURL}/admin/push-notification-messages/store`;

            const resp = await fetchRequest({
                method: 'POST',
                url,
                data: formData,
                infoBoxModelClose
            });

            if (resp?.status) {
                const targetId = isEdit ? id : resp.data.id;

                if (imageFile) {
                    const uploadData = new FormData();
                    uploadData.append('modelName', 'PushNotificationMessage');
                    uploadData.append('id', targetId);
                    uploadData.append('imageFields[]', 'image');
                    uploadData.append('image', imageFile);

                    await fetchRequest({
                        method: 'POST',
                        url: globalImageUplaodAPI(),
                        data: uploadData,
                        infoBoxModelClose
                    });
                }

                // Explicitly trigger the push notification dispatch ONLY if publish_now is selected
                if (formData.publish_type === 'publish_now') {
                    await fetchRequest({
                        method: 'POST',
                        url: `${baseURL}/admin/push-notification-messages/send/${targetId}`,
                        infoBoxModelClose
                    });
                }

                toast.success(resp.message || (formData.publish_type === 'publish_now' ? "Saved and notification sent successfully" : "Saved and scheduled successfully"));
                navigate('/push-notification-lists');
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Operation failed");
        } finally {
            setShowOverlay(false);
        }
    };

    if (loading) return <Response_Processing />;

    return (
        <>
            {showOverlay && <Response_Processing />}
            <AdminBackNavigation path="/push-notification-lists" text="Back" />
            <AdminSaveHeader
                heading={isEdit ? "Edit Push Notification" : "Add Push Notification"}
                saveText={isEdit ? "Update Notification" : "Save Notification"}
                saveMethod={handleStore}
                loading={showOverlay}
            />

            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={isEdit ? "Update Notification" : "Create Notification"} />

                        <MessageLabel text="Notification Title" className="mandatorySimple" />
                        <AdminCustomInput
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleInput}
                            placeHolder="Enter title"
                            error={formDataError.title}
                            ref={(el) => (combinedRef.current.title = el)}
                        />

                        <MessageLabel text="Menu Item URL" className="mandatorySimple" />
                        <AdminCustomSelect
                            name="url_type"
                            value={formData.url_type}
                            onChange={handleInput}
                            options={[
                                { name: "Site Url", value: "site_url" },
                                { name: "Custom Url", value: "custom_url" }
                            ]}
                        />

                        {formData.url_type === "site_url" ? (
                            <>
                                <MessageLabel text="Redirection URL" className="mandatorySimple" />
                                <AdminCustomInput
                                    type="text"
                                    name="url"
                                    value={formData.url}
                                    onChange={handleInput}
                                    placeHolder="Enter site url"
                                    appendText={`${process.env.REACT_APP_Baseurl_Frontend}/`}
                                />
                            </>
                        ) : (
                            <>
                                <MessageLabel text="Custom URL (ex: https://...)" className="mandatorySimple" />
                                <AdminCustomInput
                                    type="text"
                                    name="url"
                                    value={formData.url}
                                    onChange={handleInput}
                                    placeHolder="Enter custom url"
                                />
                            </>
                        )}

                        <MessageLabel text="Description" className="mandatorySimple" />
                        <JoditEditor
                            className={`mb-3 custom-jodit ${formDataError.description ? 'custom-input-error' : ''}`.trim()}
                            ref={(el) => (combinedRef.current.description = el)}
                            value={formData.description}
                            onChange={(newContent) => {
                                setFormData(prev => ({ ...prev, description: newContent }));
                                setFormDataError(prev => ({ ...prev, description: "" }));
                            }}
                        />
                        {formDataError.description && <div className="invalid-feedback d-block">{formDataError.description}</div>}
                    </Wrapper>
                </LeftWrapper>

                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text='Notification Image' />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={imageFile}
                            uploadedImage={formData.image}
                            onDelete={handleClearSelectFile}
                            name="image"
                            id={id}
                            error={formDataError.image}
                        />
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text='Publish Setting' />
                        <MessageLabel text='Publish Status' />
                        <div className='d-flex align-items-center justify-content-start gap-3 mt-2'>
                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="radio"
                                    id="publish_now"
                                    name="publish_type"
                                    value="publish_now"
                                    checked={formData.publish_type === 'publish_now'}
                                    onChange={handleInput}
                                    className="form-check-input"
                                />
                                <label htmlFor="publish_now" className="theme-text-color mb-0 cursor-pointer">Publish Now</label>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="radio"
                                    id="publish_later"
                                    name="publish_type"
                                    value="publish_later"
                                    checked={formData.publish_type === 'publish_later'}
                                    onChange={handleInput}
                                    className="form-check-input"
                                />
                                <label htmlFor="publish_later" className="theme-text-color mb-0 cursor-pointer">Publish Later</label>
                            </div>
                        </div>

                        {formData.publish_type === 'publish_later' && (
                            <div className="mt-3">
                                <MessageLabel text='Publish Date and Time' className="mandatorySimple" />
                                {/* react-datepicker: cross-browser including Safari (no datetime-local support) */}
                                <DatePicker
                                    selected={formData.publish_time ? new Date(formData.publish_time) : null}
                                    onChange={(date) => {
                                        // Store as LOCAL time string — cron compares against APP_TIMEZONE local "now"
                                        const localStr = date ? [
                                            date.getFullYear(),
                                            String(date.getMonth() + 1).padStart(2, '0'),
                                            String(date.getDate()).padStart(2, '0')
                                        ].join('-') + 'T' + [
                                            String(date.getHours()).padStart(2, '0'),
                                            String(date.getMinutes()).padStart(2, '0'),
                                            '00'
                                        ].join(':') : '';
                                        setFormData(prev => ({ ...prev, publish_time: localStr }));
                                        setFormDataError(prev => ({ ...prev, publish_time: '' }));
                                    }}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="yyyy-MM-dd HH:mm"
                                    minDate={new Date()}
                                    placeholderText="Select date & time"
                                    ref={(el) => (combinedRef.current.publish_time = el)}
                                    className={`custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3${formDataError.publish_time ? ' custom-input-error' : ''}`}
                                    wrapperClassName="w-100"
                                    autoComplete="off"
                                />
                                {formDataError.publish_time && <div className='d-flex align-items-center gap-1 mb-2'><span className='errorred d-block'>{formDataError.publish_time}</span></div>}
                            </div>
                        )}
                    </Wrapper>
                </RightWrapper>

                <AdminCustomButton
                    saveMethod={handleStore}
                    type="submit"
                    saveText={isEdit ? "Update Notification" : "Save Notification"}
                    className="ms-auto"
                    loading={showOverlay}
                />
            </FormContainer>
        </>
    );
}

export default AddPushNotification;
